import { createTagUrl } from '@gripp/shared-logic';
import { tokens } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { GrippTagSvg } from './grippTagSvg';

const TAG_WIDTH = 280;

/**
 * Web-only panel body that renders a tag as its printed Gripp Tag (OEM Tag v3
 * visual, see `grippTagSvg.tsx`). The QR encodes the public short URL
 * (`https://<env>.gripp.it/<tagCode>`) built by `createTagUrl` so it is
 * correct per environment. Slides in as the third column of the asset edit
 * panel when the user presses the QR icon next to a tag.
 */
export const AssetTagQrPanel = ({ tagCode }: { tagCode: string }) => {
  const { t } = useTranslation();
  const tagUrl = createTagUrl(tagCode);

  return (
    <View style={styles.container} testID="asset-tag-qr-view">
      <View
        style={styles.tagShadow}
        accessibilityRole="image"
        accessibilityLabel={t('asset.qr.tagAlt', { tagCode })}
      >
        <GrippTagSvg tagUrl={tagUrl} tagCode={tagCode} width={TAG_WIDTH} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacing.lg,
    backgroundColor: tokens.colors.brand.white,
  },
  tagShadow: {
    // Matches the design tool preview: the card radius is drawn inside the
    // SVG (8 design units), so this radius only shapes the drop shadow.
    borderRadius: 8 * (TAG_WIDTH / 348),
    ...tokens.shadows.lg,
  },
});
